import { type FC } from 'react';
import { ButtonAddStub } from './components/ButtonAdd';
import { ButtonEditStub } from './components/ButtonEdit';
import { CardsGalleryCardsStub } from '../CardsGalleryCards';

type GalleryProductCardManagerStubProps = {
    buttonAdd: { label: string };
    buttonEdit: { label: string };
};

export const GalleryProductCardManagerStub: FC<GalleryProductCardManagerStubProps> = ({
    buttonAdd: { label: labelButtonAdd },
    buttonEdit: { label: labelButtonEdit },
}) => (
    <>
        <CardsGalleryCardsStub />
        <ButtonEditStub>{labelButtonEdit}</ButtonEditStub>
        <ButtonAddStub>{labelButtonAdd}</ButtonAddStub>
    </>
);
